module.exports = __webpack_public_path__ + "img/banner-voucher.b9ad9572.png";